import React from 'react';

import Icon from '../../../assets/images/verificacao.svg';

export const IconVerificacao = (): JSX.Element => {
  return <img src={Icon} alt="Icone" width="11px" />;
};
